/* eslint-disable */
import Vue from 'vue';
import VueBury from '@souche-vue/vue-burying';
// import SPMModel from '@souche-f2e/souche-spm';
import Statistics from '@souche-f2e/statistics';

export default function statistics({ app: { router } }) {
    Vue.use(VueBury, {
        env: process.env.TRACK_ENV,
        baseOptions: {
            platform: 'C2B_PC'
        }
    });

    if (typeof window !== 'undefined') {
        import('@souche-f2e/souche-spm').then((SPMModel) => {
            SPMModel = SPMModel.default || SPMModel;

            SPMModel.init({
                env: process.env.NODE_ENV,
                source: 'C2B',
                getUserTag(userTag) {
                    Vue.buryOptions.usertag = userTag;
                }
            });

            Vue.buryOptions.marketSpm = SPMModel.getCookieSpm();

            Statistics.init({
                baidu: '14b4aac5aa4127a195c3dd1a4049180f',
                google: 'GTM-MWLMN7Q',
                piwik: {
                    userPhone: '',
                    userId: '',
                    siteId: 'souche-pc'
                },
                env: process.env.NODE_ENV,
                router, // 如果是单页面应用，请传入router
                load() {
                    return process.env.NODE_ENV === 'production';
                }
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/plugins/statistics.js